import type { AssetId } from '../hooks/useAssetId';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { AssetCommand } from './AssetCommand';

/**
 * 1) A map between an asset ID and the commands supported by the asset instance.
 * 2) A map between an asset type and the commands supported by that asset type.
 * This mapping is populated by the asset view calling useAssetCommands.
 * */
export default createStore('assetCommands', {
    assetCommandsByAssetId: new ObservableMap<AssetId, AssetCommand[]>(),
    assetCommandsByType: new ObservableMap<string, AssetCommand[]>(),
})();
